import PaymentsDataStore from '../../datastores/PaymentsDataStore';

const data = {
  payments: {
    periodDescription: '2024 - Ciclo 1 Marzo',
    discountPayment: false,
    requestBenefit: false,
    summary: {
      totalAmount: 1457.2,
      totalRecharge: 0,
      totalInstallmentsToPaid: 1176.2
    },
    items: [
      {
        itemNumber: '000000000000081',
        isPending: true,
        name: 'CUOTAS 04',
        status: 'VENCIDA',
        paymentStatus: null,
        dueDate: 1699851600000,
        hasDiscount: false,
        amountProg: 588.1,
        amount: 588.1,
        recharge: 0,
        periodDesc: '2023 - Ciclo 2 Agosto',
        paymentType: {
          id: '02',
          desc: 'PENSIONES'
        },
        discount: 0,
        billName: null
      },
      {
        itemNumber: '000000000000082',
        isPending: true,
        name: 'CUOTAS 05',
        status: 'VENCIDA',
        paymentStatus: null,
        dueDate: 1702443600000,
        hasDiscount: false,
        amountProg: 588.1,
        amount: 588.1,
        recharge: 0,
        periodDesc: '2023 - Ciclo 2 Agosto',
        paymentType: {
          id: '02',
          desc: 'PENSIONES'
        },
        discount: 0,
        billName: null
      },
      {
        itemNumber: '000000000000088',
        isPending: true,
        name: 'PROGR. DE SALUD ESTUD- VERANO',
        status: 'VENCIDA',
        paymentStatus: null,
        dueDate: 1704603600000,
        hasDiscount: false,
        amountProg: 14,
        amount: 14,
        recharge: 0,
        periodDesc: 'Verano 2024',
        paymentType: {
          id: '05',
          desc: 'SEGUROS'
        },
        discount: 0,
        billName: null
      },
      {
        itemNumber: '000000000000089',
        isPending: true,
        name: 'REINSCRIP.VERANO 80-20 y 50-50',
        status: 'VENCIDA',
        paymentStatus: null,
        dueDate: 1705122000000,
        hasDiscount: false,
        amountProg: 150,
        amount: 150,
        recharge: 0,
        periodDesc: 'Verano 2024',
        paymentType: {
          id: '01',
          desc: 'MATRÍCULA'
        },
        discount: 0,
        billName: null
      }
    ],
    itemsOthers: [
      {
        itemNumber: '000000000000090',
        isPending: true,
        name: 'RETIRO DE ASIGNATURA',
        status: 'VENCIDA',
        paymentStatus: null,
        dueDate: 1577941200000,
        hasDiscount: false,
        amountProg: 117,
        amount: 117,
        recharge: 0,
        periodDesc: '2023 - Ciclo 2 Agosto',
        paymentType: {
          id: '08',
          desc: 'TRÁMITES'
        },
        discount: 0,
        billName: null
      }
    ]
  }
};

const dataBanks = {
  paymentBank: [
    {
      name: 'Interbank',
      description:
        'Para pagos online, ingresar a "Pago o recarga"  -"Pago de instituciones y empresas"  y buscar Universidad Tecnológica del Perú  e ingresar tu DNI.',
      logoUrl: 'Logo_Interbank.png',
      appIosUrl: 'https://itunes.apple.com/pe/app/interbank-app/id378649517',
      appAndroidUrl:
        'https://play.google.com/store/apps/details?id=pe.com.interbank.mobilebanking',
      appWebUrl: 'https://bancaporinternet.interbank.pe/login',
      discount: 2.5,
      agentCode: '05 026 11',
      locationOfChannelsUrl: 'https://interbank.pe/puntos-de-atencion'
    },
    {
      name: 'BCP',
      description:
        'Elegir  la opción "Pagar  y transferir" - "Pagar un servicio", buscar UTP e ingresar tu DNI.',
      logoUrl: 'Logo_BCP.png',
      appIosUrl: 'https://apps.apple.com/pe/app/banca-móvil-bcp/id777961079',
      appAndroidUrl:
        'https://play.google.com/store/apps/details?id=com.bcp.bank.bcp',
      appWebUrl: 'https://bcpzonasegurabeta.viabcp.com/#/iniciar-sesion',
      discount: 2.5,
      agentCode: '02869',
      locationOfChannelsUrl: 'https://www.viabcp.com/canales-presenciales'
    }
  ]
};

const dataPending = {
  status: 'Success',
  message: 'User payments not paied found',
  data: {
    pendingPayments: {
      studentId: '00001249901',
      summary: {
        totalPendingAmount: 3775.82,
        totalRecharge: '0.82',
        totalInstallmentsToPaid: '3775.00'
      },
      items: [
        {
          name: 'Grado de bachiller',
          periodDesc: '2241',
          itemNumber: '000000000000301',
          amount: '1150.00',
          amountWithBenefits: '1150.00',
          amountToPay: '1150.00',
          status: 'Vencido',
          hasDiscountProntoPago: false,
          paymentType: {
            id: '08',
            desc: 'TRÁMITES'
          },
          dueDate: 1703221200000,
          billName: null,
          recharge: 0,
          discountProntoPago: 0,
          discountCicloCompleto: 0,
          discountBene: 0,
          dateCreate: 1703221200000
        },
        {
          name: 'Cuota 1',
          periodDesc: '2243',
          itemNumber: '000000000000231',
          amount: '755.00',
          amountWithBenefits: '755.00',
          amountToPay: '755.82',
          status: 'NO PAGADO',
          hasDiscountProntoPago: true,
          paymentType: {
            id: '02',
            desc: 'CUOTAS 01'
          },
          dueDate: 1723784400000,
          dateCreate: 1722661200000,
          billName: null,
          recharge: '0.56',
          discountProntoPago: 0,
          discountCicloCompleto: 0,
          discountBene: 0
        },
        {
          name: 'Cuota 2',
          periodDesc: '2243',
          itemNumber: '000000000000232',
          amount: '755.00',
          amountWithBenefits: '755.00',
          amountToPay: '755.00',
          status: 'NO PAGADO',
          hasDiscountProntoPago: true,
          paymentType: {
            id: '02',
            desc: 'CUOTAS 02'
          },
          dueDate: 1726290000000,
          dateCreate: 1722661200000,
          billName: null,
          recharge: '0.00',
          discountProntoPago: 0,
          discountCicloCompleto: 0,
          discountBene: 0
        },
        {
          name: 'Cuota 3',
          periodDesc: '2243',
          itemNumber: '000000000000233',
          amount: '755.00',
          amountWithBenefits: '755.00',
          amountToPay: '755.00',
          status: 'NO PAGADO',
          hasDiscountProntoPago: true,
          paymentType: {
            id: '02',
            desc: 'CUOTAS 03'
          },
          dueDate: 1728882000000,
          dateCreate: 1722661200000,
          billName: null,
          recharge: '0.00',
          discountProntoPago: 0,
          discountCicloCompleto: 0,
          discountBene: 0
        },
        {
          name: 'Cuota 4',
          periodDesc: '2243',
          itemNumber: '000000000000234',
          amount: '755.00',
          amountWithBenefits: '755.00',
          amountToPay: '755.00',
          status: 'NO PAGADO',
          hasDiscountProntoPago: true,
          paymentType: {
            id: '02',
            desc: 'CUOTAS 04'
          },
          dueDate: 1731560400000,
          dateCreate: 1722661200000,
          billName: null,
          recharge: '0.00',
          discountProntoPago: 0,
          discountCicloCompleto: 0,
          discountBene: 0
        },
        {
          name: 'Cuota 5',
          periodDesc: '2243',
          itemNumber: '000000000000235',
          amount: '755.00',
          amountWithBenefits: '755.00',
          amountToPay: '755.00',
          status: 'NO PAGADO',
          hasDiscountProntoPago: true,
          paymentType: {
            id: '02',
            desc: 'CUOTAS 05'
          },
          dueDate: 1734152400000,
          dateCreate: 1722661200000,
          billName: null,
          recharge: '0.00',
          discountProntoPago: 0,
          discountCicloCompleto: 0,
          discountBene: 0
        }
      ]
    }
  }
};

const dataBenefit = {
  requestBenefit: {
    requestBenefit: true,
    discountPayment: false,
    title: '¡10% de descuento pagando el ciclo completo!',
    description: 'Actívalo hasta el',
    startDate: 1627707600000,
    endDate: 1639026000000
  }
};
const dataBenefitInfo = {
  benefitInstallmentsInfo: {
    startDate: 1627772400000,
    endDate: 1627772400000,
    totalInstallments: '5',
    amountWithBenefit: '4182.75',
    totalDiscount: '418.75',
    totalAmount: '3764.5',
    validationError: null
  }
};

const dataActivateBenefitInstallments = {
  activateBenefitInstallments: {
    success: true,
    validation: null
  }
};

export default class PaymentsDataStoreMock implements PaymentsDataStore {
  getPayments() {
    return data;
  }

  getPaymentBanks() {
    return dataBanks.paymentBank;
  }

  getPendingPayments() {
    return dataPending.data;
  }

  getPaidPayments() {
    throw new Error('Method not implemented.');
  }

  getPaymentVouchers() {
    throw new Error('Method not implemented.');
  }

  generatePaymentVoucher() {
    throw new Error('Method not implemented.');
  }

  getPaymentPeriods() {
    throw new Error('Method not implemented.');
  }

  getPaymentsByPeriod() {
    throw new Error('Method not implemented.');
  }

  getBenefitInstallments() {
    return dataBenefit;
  }

  getBenefitInstallmentsInfo() {
    return dataBenefitInfo;
  }

  activateBenefitInstallments() {
    return dataActivateBenefitInstallments;
  }
}
